export type ChatUrlParams = {
  chatId: number | string;
  roomId?: string | null;
  bulletinId?: number | null;
  userId?: number | null;
  role?: 'tutor' | 'student';
  openReview?: boolean;
  /** Override default /profile/chats or /teacher/chat (e.g. details-route chats) */
  basePath?: string;
};

export function buildChatUrl(params: ChatUrlParams): string {
  const base =
    params.basePath ??
    (params.role === 'tutor' ? '/teacher/chat' : '/profile/chats');
  const search = new URLSearchParams();
  search.set('chatId', String(params.chatId));
  if (params.roomId) {
    search.set('roomId', params.roomId);
  }
  if (params.bulletinId != null) {
    search.set('bulletinId', String(params.bulletinId));
  }
  if (params.userId != null) {
    search.set('userId', String(params.userId));
  }
  if (params.openReview) {
    search.set('openReview', '1');
  }
  const query = search.toString();
  return query ? `${base}?${query}` : base;
}
